/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Analyse_RunningInputs */

const cs_ebr_analyse_running = /** @type {(inputs: Ebr_Analyse_RunningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Načítáme export a porovnáváme s CRM (nic se zatím neukládá)…`)
};

const en_ebr_analyse_running = /** @type {(inputs: Ebr_Analyse_RunningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fetching the export and comparing with the CRM (nothing is saved yet)…`)
};

/**
* | output |
* | --- |
* | "Fetching the export and comparing with the CRM (nothing is saved yet)…" |
*
* @param {Ebr_Analyse_RunningInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_analyse_running = /** @type {((inputs?: Ebr_Analyse_RunningInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Analyse_RunningInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_analyse_running(inputs)
	return cs_ebr_analyse_running(inputs)
});